<template>
  <v-col>
    <v-row>
      <v-col class="pt-3">
        <v-row>
          <v-col>
            <span class="subtitle-1 font-weight-bold">Security</span>
          </v-col>
        </v-row>

        <!-- Tenant -->
        <v-row>
          <v-col>
            <v-row>
              <v-col>
                <span class="subtitle-2 font-weight-bold">Tenant</span>
              </v-col>
            </v-row>

            <!-- "Tenant ID" Select -->
            <v-row
              class="mt-0 align-center"
            >
              <v-col
                v-if="isUserInternalDev"
                class="col-auto"
              >
                <v-select
                  v-model="tenantId"
                  :items="tenantIds"
                  label="Tenant ID"
                  dense
                  single-line
                  hide-details
                  outlined
                  width="250px"
                />
              </v-col>

              <v-col
                v-else
                class="pt-0 col-auto"
              >
                <!-- Tenant ID: Disabled Text Field with Copy Button -->
                <v-row>
                  <v-col>
                    <v-text-field
                      ref="inputTenantId"
                      v-model="tenant.tenantId"
                      label="Tenant ID"
                      dense
                      disabled
                      outlined
                      readonly
                      width="250px"
                      :value="tenant.tenantId"
                    >
                      <template v-slot:append-outer>
                        <v-btn
                          color="primary"
                          icon
                          small
                          @click="copyToClipboard(tenant.tenantId)"
                        >
                          <v-icon>content_copy</v-icon>
                        </v-btn>
                      </template>
                    </v-text-field>
                  </v-col>

                  <v-snackbar
                    v-model="showCopyMessage"
                  >
                    {{ copied ? 'Copied' : 'Failed to copy' }}
                    <v-btn
                      color="primary"

                      @click="showCopyMessage = false"
                    >
                      Close
                    </v-btn>
                  </v-snackbar>
                </v-row>
              </v-col>

              <v-spacer />

              <!-- "Add Provider" Button -->
              <v-col
                v-if="isUserInternalDev"
                class="col-auto"
              >
                <v-btn
                  color="primary"
                  @click="promptToAddProvider"
                >
                  Add Provider
                </v-btn>
              </v-col>
            </v-row>
          </v-col>
        </v-row>

        <v-row>
          <!-- Providers -->
          <v-col>
            <v-card
              v-for="domainProvider in domainProviders"
              :key="domainProvider.providerId"
              :class="inDarkMode ? 'nearblack' : 'icewhite'"
            >
              <v-card-title>
                <v-col>
                  <v-row class="align-center">
                    <v-col class="col-auto pt-1">
                      <v-row>
                        <v-col class="py-0">
                          <span class="subtitle-2 font-weight-bold">{{ domainProvider.providerName }}</span>
                        </v-col>
                      </v-row>

                      <v-row>
                        <v-col class="py-0">
                          <span class="caption font-weight-medium">{{ domainProvider.providerDescription }}</span>
                        </v-col>
                      </v-row>
                    </v-col>

                    <v-spacer />

                    <v-col class="col-auto">
                      <v-switch
                        v-model="domainProvider.isActive"
                        label="Enabled"
                        class="caption font-weight-medium"
                        @click="promptToUpdateProviderStatus(domainProvider)"
                      />

                      <v-dialog
                        v-model="showViewToDisableProvider"
                        max-width="500"
                      >
                        <v-card>
                          <v-card-title>
                            <v-row>
                              <v-col class="pt-4">
                                <h3 class="headline">
                                  Disable Provider
                                </h3>
                              </v-col>

                              <v-col class="col-auto mt-2">
                                <v-btn
                                  :ripple="false"
                                  icon
                                  small
                                  @click="cancelDisableProvider"
                                >
                                  <v-icon
                                    :color="inDarkMode ? 'white' : 'black'"
                                    icon="close"
                                  >
                                    close
                                  </v-icon>
                                </v-btn>
                              </v-col>
                            </v-row>
                          </v-card-title>

                          <v-card-text>
                            <v-row>
                              <v-col>
                                <span class="caption font-weight-medium">Are you sure you want to disable the {{ domainProvider.providerName }} provider?</span>
                              </v-col>
                            </v-row>

                            <v-row class="align-center">
                              <v-btn
                                :color="inDarkMode ? 'white' : 'black'"
                                text
                                @click="cancelDisableProvider"
                              >
                                Cancel
                              </v-btn>

                              <v-spacer />

                              <v-col class="text-right">
                                <v-btn
                                  color="primary"
                                  width="150px"
                                  @click="disableProvider(domainProvider)"
                                >
                                  Yes
                                </v-btn>
                              </v-col>
                            </v-row>
                          </v-card-text>
                        </v-card>
                      </v-dialog>

                      <v-dialog
                        v-model="showViewToEnableProvider"
                        max-width="500"
                      >
                        <v-card>
                          <v-card-title>
                            <v-row>
                              <v-col class="pt-4">
                                <h3 class="headline">
                                  Enable Provider
                                </h3>
                              </v-col>

                              <v-col class="col-auto mt-2">
                                <v-btn
                                  :ripple="false"
                                  icon
                                  small
                                  @click="cancelEnableProvider"
                                >
                                  <v-icon
                                    :color="inDarkMode ? 'white' : 'black'"
                                    icon="close"
                                  >
                                    close
                                  </v-icon>
                                </v-btn>
                              </v-col>
                            </v-row>
                          </v-card-title>

                          <v-card-text>
                            <v-row>
                              <v-col>
                                <span class="caption font-weight-medium">Are you sure you want to enable the {{ domainProvider.providerName }} provider?</span>
                              </v-col>
                            </v-row>

                            <v-row class="align-center">
                              <v-btn
                                :color="inDarkMode ? 'white' : 'black'"
                                text
                                @click="cancelEnableProvider"
                              >
                                Cancel
                              </v-btn>

                              <v-spacer />

                              <v-col class="text-right">
                                <v-btn
                                  color="primary"
                                  width="150px"
                                  @click="enableProvider(domainProvider)"
                                >
                                  Yes
                                </v-btn>
                              </v-col>
                            </v-row>
                          </v-card-text>
                        </v-card>
                      </v-dialog>
                    </v-col>
                  </v-row>

                  <v-row v-if="domainProvider.providerType === 'saml'">
                    <v-col>
                      <v-divider />
                    </v-col>
                  </v-row>

                  <v-row
                    v-if="domainProvider.providerType === 'saml'"
                    class="align-center"
                  >
                    <v-col class="py-0 col-auto">
                      <span class="caption font-weight-bold mr-1">Type</span>
                      <span class="caption font-weight-medium text-uppercase">{{ domainProvider.providerType }}</span>
                    </v-col>

                    <v-col class="py-0 col-auto">
                      <span class="caption font-weight-bold mr-1">ID</span>
                      <span class="caption font-weight-medium">{{ domainProvider.providerId }}</span>
                    </v-col>

                    <v-spacer />

                    <v-col class="col-auto">
                      <v-row>
                        <v-col>
                          <v-btn
                            color="primary"
                            small
                            outlined
                            @click="promptToUpdateProvider(domainProvider)"
                          >
                            Edit Config
                          </v-btn>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-col>
              </v-card-title>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <!-- "Update Provider" Dialog -->
    <v-dialog
      v-model="showViewToUpdateProvider"
      max-width="950px"
    >
      <v-card>
        <v-card-title>
          <v-row>
            <v-col class="pt-4">
              <h3 class="headline">
                Update Provider
              </h3>
            </v-col>

            <v-col class="col-auto mt-2">
              <v-btn
                :ripple="false"
                icon
                small
                @click="cancelUpdateProvider"
              >
                <v-icon
                  :color="inDarkMode ? 'white' : 'black'"
                  icon="close"
                >
                  close
                </v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-card-title>

        <v-card-text class="mt-4">
          <!-- "Update Provider" Display Name -->
          <v-row>
            <v-col>
              <v-text-field
                v-model="providerForm.displayName"
                class="d-block"
                label="Display Name"
                dense
                outlined
                required
                single-line
                hide-details
              >
                <!-- Append-outer the provider ID -->
                <template v-slot:append-outer>
                  <v-row>
                    <v-col class="pa-0 ml-2">
                      <span class="caption font-weight-medium">{{ providerForm.providerId }}</span>
                    </v-col>
                  </v-row>
                </template>
              </v-text-field>
            </v-col>
          </v-row>

          <!-- "Update Provider" Provider Entity ID -->
          <v-row>
            <v-col>
              <v-text-field
                v-model="providerForm.rpEntityId"
                label="iAdOps Entity ID"
                dense
                outlined
                required
                hint="The URL of the relying party."
              />
            </v-col>
          </v-row>

          <!-- "Update Provider" Callback URL -->
          <v-row class="mt-0">
            <v-col>
              <v-text-field
                v-model="providerForm.callbackURL"
                label="iAdOps Callback URL"
                dense
                outlined
                required
                hint="The URL to handle the response from the identity provider."
              />
            </v-col>
          </v-row>

          <!-- "Update Provider" IDP Entity ID -->
          <v-row class="mt-0">
            <v-col>
              <v-text-field
                v-model="providerForm.idpEntityId"
                label="IDP Entity ID"
                dense
                outlined
                required
                hint="A URI that identifies the identity provider."
              />
            </v-col>
          </v-row>

          <!-- "Update Provider" IDP SSO URL -->
          <v-row class="mt-0">
            <v-col>
              <v-text-field
                v-model="providerForm.ssoURL"
                label="IDP SSO URL"
                dense
                outlined
                required
                hint="The URL of the identity provider's sign-in page."
              />
            </v-col>
          </v-row>

          <!-- "Update Provider" X.509 Certificates -->
          <v-row class="mt-0">
            <v-col>
              <v-textarea
                v-model="providerForm.x509Certificates"
                hint="The certificate used to validate tokens signed by the identity provider."
                label="X.509 Certificates"
                outlined
                required
              />
            </v-col>
          </v-row>

          <!-- "Update Provider" Enable Request Signing? -->
          <v-row class="mt-0">
            <v-col>
              <v-checkbox
                v-model="providerForm.enableRequestSigning"
                class="mt-0"
                label="Enable Request Signing?"
              />
            </v-col>
          </v-row>

          <!-- Divider -->
          <v-row>
            <v-col>
              <v-divider />
            </v-col>
          </v-row>

          <!-- "Update Provider" Success Message -->
          <v-row
            v-if="successUpdatingProvider"
            class="justify-center mx-0 my-4 pa-3 rounded-lg icewhite"
          >
            <v-col class="pa-4">
              <span class="caption font-weight-medium">Provider updated successfully.</span>
            </v-col>
          </v-row>

          <!-- "Update Provider" Error Message -->
          <v-row
            v-else-if="errorUpdatingProvider"
            class="justify-center mx-0 my-4 pa-3 rounded-lg icewhite"
          >
            <v-col class="pa-4">
              <span class="caption font-weight-medium">{{ errorUpdatingProvider }}</span>
            </v-col>
          </v-row>

          <v-row class="justify-end">
            <v-col>
              <v-btn
                :color="inDarkMode ? 'white' : 'black'"
                text
                @click="cancelUpdateProvider"
              >
                Cancel
              </v-btn>
            </v-col>

            <v-col class="text-right">
              <v-btn
                color="primary"
                width="150px"
                @click="updateProvider(providerForm)"
              >
                Submit
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- "Add Provider" Dialog -->
    <v-dialog
      v-model="showViewToAddProvider"
      max-width="950px"
    >
      <v-card>
        <v-card-title>
          <v-row>
            <v-col class="pt-4">
              <h3 class="headline">
                Add Provider
              </h3>
            </v-col>

            <v-col class="col-auto mt-2">
              <v-btn
                :ripple="false"
                icon
                small
                @click="cancelAddProvider"
              >
                <v-icon
                  :color="inDarkMode ? 'white' : 'black'"
                  icon="close"
                >
                  close
                </v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-card-title>

        <v-card-text class="mt-4">
          <v-row>
            <v-col>
              <span class="caption font-weight-medium">Add a new provider to the {{ domainName }} domain's {{ tenantId }} tenant.</span>
            </v-col>
          </v-row>

          <!-- "Add Provider" Provider Type -->
          <v-row>
            <v-col>
              <v-select
                v-model="providerForm.providerType"
                :items="providerTypes"
                label="Provider Type"
                dense
                outlined
                required
              />
            </v-col>
          </v-row>

          <!-- "Add Provider" Display Name -->
          <v-row class="mt-0">
            <v-col>
              <v-text-field
                v-model="providerForm.displayName"
                label="Display Name"
                dense
                outlined
                required
              />
            </v-col>
          </v-row>

          <!-- "Add Provider" Provider ID -->
          <v-row class="mt-0">
            <v-col>
              <v-text-field
                v-model="providerForm.providerId"
                label="Provider ID"
                dense
                outlined
                required
              />
            </v-col>
          </v-row>

          <!-- "Add Provider" Description -->
          <v-row class="mt-0">
            <v-col>
              <v-text-field
                v-model="providerForm.providerDescription"
                label="Description"
                dense
                outlined
                hint="A description of the provider."
              />
            </v-col>
          </v-row>

          <v-row
            v-if="providerForm.providerType === 'google.com'"
            class="mt-0"
          >
            <v-col>
              <v-text-field
                v-model="providerForm.scope"
                label="Scope"
                dense
                outlined
                hint="The scope of the provider."
              />
            </v-col>
          </v-row>

          <!-- "Add Provider" RP Entity ID -->
          <v-row
            v-if="providerForm.providerType === 'saml'"
            class="mt-0"
          >
            <v-col>
              <v-text-field
                v-model="providerForm.rpEntityId"
                label="iAdOps Entity ID"
                dense
                outlined
                required
                hint="The URL of the relying party."
              />
            </v-col>
          </v-row>

          <!-- "Add Provider" Callback URL -->
          <v-row
            v-if="providerForm.providerType === 'saml'"
            class="mt-0"
          >
            <v-col>
              <v-text-field
                v-model="providerForm.callbackURL"
                label="iAdOps Callback URL"
                dense
                outlined
                required
                hint="The URL to handle the response from the identity provider."
              />
            </v-col>
          </v-row>

          <!-- "Add Provider" IDP Entity ID -->
          <v-row
            v-if="providerForm.providerType === 'saml'"
            class="mt-0"
          >
            <v-col>
              <v-text-field
                v-model="providerForm.idpEntityId"
                label="IDP Entity ID"
                dense
                outlined
                required
              />
            </v-col>
          </v-row>

          <!-- "Add Provider" SSO URL -->
          <v-row
            v-if="providerForm.providerType === 'saml'"
            class="mt-0"
          >
            <v-col>
              <v-text-field
                v-model="providerForm.ssoURL"
                label="SSO URL"
                dense
                outlined
                required
                hint="The URL of the identity provider's sign-in page."
              />
            </v-col>
          </v-row>

          <!-- "Add Provider" X.509 Certificates -->
          <v-row
            v-if="providerForm.providerType === 'saml'"
            class="mt-0"
          >
            <v-col>
              <v-textarea
                v-model="providerForm.x509Certificates"
                hint="The certificate used to validate tokens signed by the identity provider."
                label="X.509 Certificates"
                dense
                outlined
                required
              />
            </v-col>
          </v-row>

          <!-- "Add Provider" Enable Request Signing -->
          <v-row
            v-if="providerForm.providerType === 'saml'"
            class="mt-0"
          >
            <v-col>
              <v-checkbox
                v-model="providerForm.enableRequestSigning"
                class="mt-0"
                label="Enable Request Signing"
              />
            </v-col>
          </v-row>

          <!-- "Create Provider" Enabled -->
          <v-row class="mt-0">
            <v-col>
              <v-checkbox
                v-model="providerForm.isActive"
                class="mt-0"
                label="Enable"
              />
            </v-col>
          </v-row>

          <!-- "Create Provider" Primary -->
          <v-row class="mt-0">
            <v-col>
              <v-checkbox
                v-model="providerForm.isPrimary"
                class="mt-0"
                label="Primary Provider"
                hint="The primary provider is the default identity provider for the domain."
              />
            </v-col>
          </v-row>

          <!-- Divider -->

          <v-row>
            <v-col>
              <v-divider />
            </v-col>
          </v-row>

          <v-row
            v-if="successAddingProvider"
            class="justify-center mx-0 my-4 pa-3 rounded-lg icewhite"
          >
            <v-col class="pa-4">
              <span class="caption font-weight-medium">Provider added successfully.</span>
            </v-col>
          </v-row>

          <v-row
            v-else-if="errorAddingProvider"
            class="justify-center mx-0 my-4 pa-3 rounded-lg icewhite"
          >
            <v-col class="pa-4">
              <span class="caption font-weight-medium">{{ errorAddingProvider }}</span>
            </v-col>
          </v-row>

          <v-row class="justify-end">
            <v-col>
              <v-btn
                :color="inDarkMode ? 'white' : 'black'"
                text
                @click="showViewToAddProvider = false"
              >
                Cancel
              </v-btn>
            </v-col>

            <v-col class="text-right">
              <v-btn
                color="primary"
                width="150px"
                @click="createProvider(providerForm)"
              >
                Submit
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-col>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'

const { mapGetters: mapAuthGetters, mapState: mapAuthState } = createNamespacedHelpers('auth')
const { mapState: mapToolsState } = createNamespacedHelpers('tools')

export default {
  name: 'AdminSecurity',
  data() {
    return {
      // Server-provided data.
      domainProviders: [],
      tenant: {},
      tenants: [],

      // Copy to clipboard.
      copied: false,
      showCopyMessage: false,

      // Local data.
      errorUpdatingProvider: '',
      successUpdatingProvider: false,
      showViewToUpdateProvider: false,

      showViewToDisableProvider: false,
      showViewToEnableProvider: false,

      errorAddingProvider: '',
      successAddingProvider: false,
      showViewToAddProvider: false,
    }
  },
  computed: {
    ...mapAuthGetters([
      'inDarkMode',
      'isUserInternalAdmin',
      'isUserInternalDev',
      'userEmail',
    ]),
    ...mapAuthState({
      $domainDoc: (state) => state.domainDoc,
      $domainForm: (state) => state.domainForm,
      $domainName: (state) => state.domainName,

      $enterpriseDoc: (state) => state.enterpriseDoc,
      $enterpriseDocs: (state) => state.enterpriseDocs,
      $enterpriseForm: (state) => state.enterpriseForm,
      $enterpriseId: (state) => state.enterpriseId,

      $providerDoc: (state) => state.providerDoc, // Document of provider collection.
      $providerDocs: (state) => state.providerDocs,
      $providerId: (state) => state.providerId, // providerId of the provider used to sign in.
      $providerForm: (state) => state.providerForm,
      $providerTypes: (state) => state.providerTypes,

      $tenantId: (state) => state.tenantId,
    }),
    ...mapToolsState({
      selectedSearch: (state) => state.selectedSearch,
    }),

    reportId() {
      return this.selectedSearch && this.selectedSearch.reportId
    },

    urlOrigin() {
      return window.location.origin
    },

    domainName: {
      get() {
        return this.$domainName
      },
      set(value) {
        this.$store.commit('auth/domainName', value)
      },
    },
    domainDoc: {
      get() {
        return this.$domainDoc
      },
      set(value) {
        this.$store.commit('auth/domainDoc', value)
      },
    },
    domainForm: {
      get() {
        return this.$domainForm
      },
      set(value) {
        this.$store.commit('auth/domainForm', value)
      },
    },
    enterpriseDoc: {
      get() {
        return this.$enterpriseDoc
      },
      set(value) {
        this.$store.commit('auth/enterpriseDoc', value)
      },
    },
    enterpriseDocs: {
      get() {
        return this.$enterpriseDocs
      },
      set(value) {
        this.$store.commit('auth/enterpriseDocs', value)
      },
    },
    enterpriseForm: {
      get() {
        return this.$enterpriseForm
      },
      set(value) {
        this.$store.commit('auth/enterpriseForm', value)
      },
    },
    enterpriseId: {
      get() {
        return this.$enterpriseId
      },
      set(value) {
        this.$store.commit('auth/enterpriseId', value)
      },
    },
    providerDoc: {
      get() {
        return this.$providerDoc
      },
      set(value) {
        this.$store.commit('auth/providerDoc', value)
      },
    },
    providerDocs: {
      get() {
        return this.$providerDocs
      },
      set(value) {
        this.$store.commit('auth/providerDocs', value)
      },
    },
    providerForm: {
      get() {
        return this.$providerForm
      },
      set(value) {
        this.$store.commit('auth/providerForm', value)
      },
    },
    providerId: {
      get() {
        return this.$providerId
      },
      set(value) {
        this.$store.commit('auth/providerId', value)
      },
    },
    providerTypes: {
      get() {
        return this.$providerTypes
      },
      set(value) {
        this.$store.commit('auth/providerTypes', value)
      },
    },

    tenantId: {
      get() {
        return this.$tenantId
      },
      set(value) {
        this.$store.commit('auth/tenantId', value)
      },
    },

    tenantIds() {
      return this.tenants.map((tenant) => ({
        text: tenant.tenantId,
        value: tenant.tenantId,
      }))
    },
  },

  watch: {
    // Update providers on change of tenant.
    async tenantId(newValue) {
      // Get the domain that has the new tenantId in its providers array.
      return this.setup(newValue)
    },
  },

  created() {
    // Get the domain that has the current user's tenantId in its providers array.
    // The AuthStore's tenantId is set as part of the sign-in workflow.
    this.setup(this.tenantId)
  },
  methods: {
    async getDomainDoc(tenantId) {
      // Get the domain that has the tenantId in its providers array.
      const domainDoc = await this.$store.dispatch('auth/getDomainByTenantId', tenantId)

      if (!domainDoc) {
        this.$store.commit('tools/snackbar', true, { root: true })
        this.$store.commit('tools/snack', { message: 'An unknown error occurred while getting the domain.', status: 'error' }, { root: true })
      } else if (domainDoc.error) {
        const { error } = domainDoc
        const { message } = typeof error === 'object' ? error : domainDoc

        this.$store.commit('tools/snackbar', true, { root: true })
        this.$store.commit('tools/snack', { message: message || 'An error occurred while getting the domain.', status: 'error' }, { root: true })
      }

      return domainDoc
    },

    async getDomainName(domainDoc) {
      return domainDoc.domainName || domainDoc.docId
    },

    async listProviders(domainName) {
      return this.$store.dispatch('auth/listProviders', domainName)
    },

    async getProviders(domainName) {
      return this.listProviders(domainName)
    },

    async setup(tenantId) {
      if (this.isUserInternalDev) {
        this.tenants = await this.getTenants()
      } else {
        this.tenant = await this.getTenant(tenantId)
      }

      // Get the domain that has the tenantId in its providers array.
      this.domainDoc = await this.getDomainDoc(tenantId)

      this.domainName = await this.getDomainName(this.domainDoc)

      // Providers are based on the domain's providers array.
      this.domainProviders = await this.getProviders(this.domainName)

      return true
    },

    async getTenant(tenantId) {
      const tenant = await this.$store.dispatch('auth/getTenant', tenantId)

      if (!tenant) {
        this.$store.commit('tools/snackbar', true, { root: true })
        this.$store.commit('tools/snack', { message: 'Empty response while getting tenant.', status: 'error' }, { root: true })
      }

      if (tenant.error) {
        const { error } = tenant
        const { message } = typeof error === 'object' ? error : tenant

        this.$store.commit('tools/snackbar', true, { root: true })
        this.$store.commit('tools/snack', { message: message || 'Failed to get tenant.', status: 'error' }, { root: true })
      }

      return tenant
    },

    async getTenants() {
      const tenants = await this.$store.dispatch('auth/listTenants')

      if (!tenants || tenants.error) {
        this.$store.commit('tools/snackbar', true, { root: true })
        this.$store.commit('tools/snack', { message: 'Failed to get tenants.', status: 'error' }, { root: true })
      }

      return tenants
    },

    async promptToAddProvider() {
      // Clear other views.
      this.showViewToEnableProvider = false
      this.showViewToDisableProvider = false

      // Reset error and success messages.
      this.errorAddingProvider = ''
      this.successAddingProvider = false

      // Prepare the form.
      // Set the form.
      this.providerForm = {
        callbackURL: `${this.urlOrigin}/__/auth/handler`,
        enableRequestSigning: false,
        rpEntityId: this.urlOrigin,
      }

      // Render the form view.
      this.showViewToAddProvider = true
    },

    cancelAddProvider() {
      // Hide the view.
      this.showViewToAddProvider = false

      // Reset the form.
      this.providerForm = {}

      // Reset error and success messages.
      this.errorAddingProvider = ''
      this.successAddingProvider = false
    },

    promptToDisableProvider(providerDoc) {
      this.providerForm = providerDoc
      this.showViewToDisableProvider = true
    },

    promptToEnableProvider(providerDoc) {
      this.providerForm = providerDoc
      this.showViewToEnableProvider = true
    },

    promptToUpdateProviderStatus(providerDoc) {
      if (providerDoc.isActive) {
        this.promptToEnableProvider(providerDoc)
      } else {
        this.promptToDisableProvider(providerDoc)
      }
    },

    cancelDisableProvider(providerDoc) {
      providerDoc.isActive = true

      this.showViewToDisableProvider = false
      this.providerForm = {}
    },

    cancelEnableProvider(providerDoc) {
      providerDoc.isActive = false

      this.showViewToEnableProvider = false
      this.providerForm = {}
    },

    async disableProvider(providerDoc) {
      const { domainName } = this
      const { providerId } = providerDoc
      const providerData = {
        enabled: false,
        isActive: false,
      }

      const result = await this.$store.dispatch('auth/disableProvider', { domainName, providerData, providerId })

      if (!result) {
        this.$store.commit('tools/snackbar', true, { root: true })
        this.$store.commit('tools/snack', { message: 'An unknown error occurred while disabling the provider.', status: 'error' }, { root: true })
      }

      if (result.error) {
        const { error } = result
        const { message } = typeof error === 'object' ? error : result
        const defaultErrorMessage = 'An error occurred while disabling the provider. Please contact support for assistance.'

        this.$store.commit('tools/snackbar', true, { root: true })
        this.$store.commit('tools/snack', { message: message || defaultErrorMessage, status: 'error' }, { root: true })

        return result
      }

      // Inform the user of the success.
      this.$store.commit('tools/snackbar', true, { root: true })
      this.$store.commit('tools/snack', { message: 'Provider disabled successfully.', status: 'success' }, { root: true })

      // Hide the view.
      this.showViewToDisableProvider = false

      // Reset the form.
      this.providerForm = {}

      return result
    },

    async enableProvider(providerDoc) {
      const { domainName } = this
      const { providerId } = providerDoc

      const providerData = {
        enabled: true,
        isActive: true,
        providerId,
      }

      const result = await this.$store.dispatch('auth/enableProvider', { domainName, providerData, providerId })

      if (!result) {
        this.$store.commit('tools/snackbar', true, { root: true })
        this.$store.commit('tools/snack', { message: 'An unknown error occurred while enabling the provider.', status: 'error' }, { root: true })
      }

      if (result.error) {
        const { error } = result
        const { message } = typeof error === 'object' ? error : result
        const defaultErrorMessage = 'An error occurred while enabling the provider. Please contact support for assistance.'

        this.$store.commit('tools/snackbar', true, { root: true })
        this.$store.commit('tools/snack', { message: message || defaultErrorMessage, status: 'error' }, { root: true })

        return result
      }

      // Inform the user of the success.
      this.$store.commit('tools/snackbar', true, { root: true })
      this.$store.commit('tools/snack', { message: 'Provider enabled successfully.', status: 'success' }, { root: true })

      // Hide the view.
      this.showViewToEnableProvider = false

      // Reset the form.
      this.providerForm = {}

      return result
    },

    promptToUpdateProvider(domainProvider) {
      // Clear other views.
      this.showViewToEnableProvider = false
      this.showViewToDisableProvider = false

      // Reset error and success messages.
      this.errorUpdatingProvider = ''
      this.successUpdatingProvider = false

      const { x509Certificates } = domainProvider
      const certificates = Array.isArray(x509Certificates) ? x509Certificates.join('\n\n') : x509Certificates

      // Prepare the form.
      const overwrites = {
        callbackURL: domainProvider.callbackURL || `${this.urlOrigin}/__/auth/handler`,
        displayName: domainProvider.displayName || domainProvider.providerName,
        enableRequestSigning: domainProvider.enableRequestSigning || false,
        idpEntityId: domainProvider.idpEntityId || '',
        rpEntityId: domainProvider.rpEntityId || this.urlOrigin,
        ssoURL: domainProvider.ssoURL || '',
        x509Certificates: certificates,
      }

      // Set the form.
      this.providerForm = { ...domainProvider, ...overwrites }

      // Render the form view.
      this.showViewToUpdateProvider = true
    },

    cancelUpdateProvider() {
      // Hide the view.
      this.showViewToUpdateProvider = false

      // Reset the form.
      this.providerForm = {}

      // Reset error and success messages.
      this.errorUpdatingProvider = ''
      this.successUpdatingProvider = false
    },

    async updateProvider(providerForm) {
      const { domainName } = this
      const { providerId, x509Certificates } = providerForm

      const certificates = typeof x509Certificates === 'string' ? x509Certificates.split('\n\n') : x509Certificates

      const providerData = {
        // Primary key.
        providerId: providerForm.providerId,

        // Domain provider properties.
        isActive: typeof providerForm.isActive === 'boolean' ? providerForm.isActive : false, // Same as enabled on provider config.
        isPrimary: typeof providerForm.isPrimary === 'boolean' ? providerForm.isPrimary : false,

        // Provider document properties.
        providerName: providerForm.displayName, // Same as displayName on provider config.

        // Identity provider properties.
        displayName: providerForm.displayName, // Same as providerName on provider doc.
        enabled: typeof providerForm.isActive === 'boolean' ? providerForm.isActive : false, // Same as isActive on provider doc.

        idpEntityId: providerForm.idpEntityId,
        ssoURL: providerForm.ssoURL,
        x509Certificates: certificates,

        // Service provider (iAdOps) properties.
        rpEntityId: providerForm.rpEntityId,
        callbackURL: providerForm.callbackURL,
      }

      const editResult = await this.$store.dispatch('auth/updateProvider', { domainName, providerId, providerData })

      if (!editResult) {
        this.$store.commit('tools/snackbar', true, { root: true })
        this.$store.commit('tools/snack', { message: 'Update Provider Error Unknown', status: 'error' }, { root: true })

        this.errorUpdatingProvider = 'An empty response occurred while updating the provider. Please contact support for assistance.'
      }

      if (editResult.error) {
        const { error } = editResult
        const { message } = typeof error === 'object' ? error : editResult

        // Set the error message.
        this.errorUpdatingProvider = message || 'An error occurred while updating the provider. Please contact support for assistance.'

        // Exit.
        return editResult
      }

      const endpoints = ['config', 'domain', 'provider']
      const endpointErrors = endpoints.reduce((errors, endpointKey) => {
        const endpointResult = editResult[endpointKey]

        if (endpointResult.error) {
          errors.push(endpointResult)
        }

        return errors
      }, [])

      if (endpointErrors.length) {
        this.errorUpdatingProvider = endpointErrors.map((endpoint) => {
          if (endpoint.message === 'Request is missing "AuthProviderConfig" configuration.') {
            return 'The provider configuration is missing properties required by the "AuthProviderConfig" configuration. Please review the configuration and try again.'
          }

          return endpoint.message
        }).join('\n\n')
      } else {
        this.successUpdatingProvider = true
      }

      return editResult
    },

    createProvider(providerForm) {
      const { domainName } = this
      const { providerId } = providerForm

      const providerData = {
        // Primary key.
        providerId: providerForm.providerId,

        // Domain provider properties.
        isActive: typeof providerForm.isActive === 'boolean' ? providerForm.isActive : false,
        isPrimary: typeof providerForm.isPrimary === 'boolean' ? providerForm.isPrimary : false,

        // Provider document properties.
        providerName: providerForm.providerName,

        // Identity provider properties.
        displayName: providerForm.displayName,
        enabled: typeof providerForm.isActive === 'boolean' ? providerForm.isActive : false,

        idpEntityId: providerForm.idpEntityId,
        ssoURL: providerForm.ssoURL,
        x509Certificates: providerForm.x509Certificates,

        // Service provider (iAdOps) properties.
        rpEntityId: providerForm.rpEntityId,
        callbackURL: providerForm.callbackURL,
      }

      const createResult = this.$store.dispatch('auth/createProvider', { domainName, providerId, providerData })

      if (createResult) {
        this.successAddingProvider = true
      } else {
        this.errorAddingProvider = 'Failed to create the provider.'
      }

      return createResult
    },

    async deleteProvider(provider) {
      this.providerForm = provider

      const deleteResult = this.$store.dispatch('auth/deleteProvider', provider)

      if (deleteResult) {
        this.successUpdatingProvider = true
      } else {
        this.errorUpdatingProvider = 'Failed to delete the provider.'
      }
    },

    onCopySuccess() {
      this.copied = true
      this.showCopyMessage = true

      return true
    },

    onCopyError() {
      this.copied = false
      this.showCopyMessage = true

      return false
    },

    copyToClipboardFallback() {
      const el = this.$refs.inputTenantId

      if (!el.length) return this.onCopyError()

      el[0].select()

      document.execCommand('copy')

      return this.onCopySuccess()
    },

    async copyToClipboard(text) {
      if (!navigator.clipboard) {
        return this.copyToClipboardFallback(text)
      }

      return navigator.clipboard.writeText(text).catch(() => this.copyToClipboardFallback(text))
    },
  },
}
</script>
